module.exports = __webpack_public_path__ + "static/media/kudos-commnet-sent-icon.784de032.svg";